/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-29 19:57:59
 * @Description: 
 */
import React, { useState } from "react";
import Header from "src/pages/Headers";
import DialogOpenApp from "src/components/DialogOpenApp";
import ToolLeft from "src/pages/ToolLeft/ToolLeft";
import "./Layout.scss"
import FTCenter from "src/pages/Content/FTCenter";
import { autorun } from "mobx";
import FTCanvasStore from "src/store/FTCanvasStore";
import FTImageStore from "src/store/FTImageStore";
import FTEffectLoading from "./FTLoading/FTEffectLoading";
import FTDownloadLoading from "./FTLoading/FTDownloadLoading";
import { defaultLength } from "src/constant";
import ToolLeftMobile from "src/pages/ToolLeft/ToolLeftMobile";
import utils from "src/utils";
import FTDownloadMobile from "./FTDownloadMobile/FTDownloadMobile";
import FTUserStore from "src/store/FTUserStore";
import { IconClose, IconVip } from "src/assets";
import FTLang from "src/utils/FTLang";
import ScriptModal from "./ScriptModal";

export default function Layout() {
  let [loading, setLoading] = React.useState(false)
  let [effectLoading, setEffectLoading] = React.useState(false)
  let [downloadLoading, setDownloadLoading] = React.useState(false)
  let [isMobile, setIsMobile] = React.useState(false)
  let [showDownload, setShowDownload] = React.useState(false)
  let [currentImage, setCurrentImage] = React.useState(false)
  let [showAd, setShowAd ] = React.useState(true)
  let [useActivity, setUseActivity] = React.useState<any>("")
  let initAd = React.useRef(false)

  const [hasNeedRoot,setHasNeedRoot]=useState(false)
  React.useEffect(() => {
    autorun(() => {
      let { isVip, showCountryAd } = FTUserStore
      setLoading(FTCanvasStore.loading)
      setDownloadLoading(FTCanvasStore.downloadLoading)
      setEffectLoading(FTImageStore.loading)
      setCurrentImage(FTImageStore.currentImage)
      setIsMobile(FTCanvasStore.isMobile)
      setShowDownload(FTCanvasStore.showDownload)
      setHasNeedRoot(FTImageStore.checkRoot.need)

      if(FTImageStore.currentImage && !FTCanvasStore.isMobile && !isVip && !showCountryAd && !initAd.current) {
        document.getElementById("fotorAdWapper")!.style.display = "block"
        setShowAd(true)
        testGAReady()
      } else {
        if(((isVip || showCountryAd) && FTImageStore.currentImage) || !FTImageStore.currentImage || FTCanvasStore.isMobile) {
          let event = new CustomEvent("hideAds");
          document.dispatchEvent(event);
          document.getElementById("fotorAdWapper")!.style.display = "none"
          setShowAd(false)
        } else {
          document.getElementById("fotorAdWapper")!.style.display = "block"
          setShowAd(true)
        }
      }
    })
    computedIsMobile()
    window.addEventListener("resize", computedIsMobile)
    FTUserStore.getUserActivity().then(() => {
      if(FTUserStore.showFreeTry) {
        setUseActivity("try")
      } else if(FTUserStore.showDiscount) {
        setUseActivity("discount")
      } else {
        setUseActivity("")
      }
    })
    // 請求特效列表
    FTImageStore.getEffectList()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  

  const computedIsMobile = () => {
    let { isMobile, iPad } = utils.myBrowserOS()
    if(isMobile || iPad) {
      FTCanvasStore.setIsMobile(true)
      return
    }
    let width = window.innerWidth
    if(width <= defaultLength.MOBILE_WIDTH && !FTCanvasStore.isMobile) {
      FTCanvasStore.setIsMobile(true)
    } else if(width > defaultLength.MOBILE_WIDTH && FTCanvasStore.isMobile) {
      FTCanvasStore.setIsMobile(false)
    }
  }
  
  const closeAD = () =>  {
    if(!FTUserStore.userInfo) {
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_remove_ad"
        }, 
        isShowScenses: true,
        otherParam: {
          scenesId: "015",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: () => {
          closeAD()
        }
      })
    } else {
      if(!FTUserStore.isVip) {
        FTUserStore.showPaymnet({
          vipType: "vip",
          position: "goart_remove_ad",
          otherParam: {
            scenesId: "012"
          },
          callback: () => {
            closeAD()
          }
        })
      }
    }
  }

  const setGoogleAD = () => {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(function () {
        window.googletag.pubads().enableAsyncRendering();
        window.googletag.pubads().disableInitialLoad();
    });
    // @ts-ignore
    (adsbygoogle = window.adsbygoogle || []).pauseAdRequests = 1;
    // @ts-ignore
    __tcfapi("addEventListener", 2, function(tcData, success) {
        if (success && tcData.unicLoad  === true) {
            if(!window._initAds) {
                window._initAds = true;
            var script = document.createElement('script');
            script.async = true;
            script.src = 'https://dsh7ky7308k4b.cloudfront.net/publishers/fotorcomhardcoded.min.js';
            script.onload = function() {
              let googletag = window.googletag;

              googletag.cmd.push(function() {
                googletag.display("div-gpt-ad-fotorcom41274");
                googletag.display("div-gpt-ad-fotorcom41275");
              });
              let event = new CustomEvent("showAds");
              document.dispatchEvent(event);
            };
            document.head.appendChild(script);

            var _script = document.createElement('script');
            _script.async = true;
            _script.src = 'https://btloader.com/tag?o=5184339635601408&upapi=true';
            document.head.appendChild(_script);
          }
        }
    });
  }

  const testGAReady = async () => {
    initAd.current = true
    await utils.loadJsScript("https://cmp.uniconsent.com/v2/stub.min.js");
    await utils.loadJsScript("https://cmp.uniconsent.com/v2/48a3eb8636/cmp.js");
    let googleReady = setInterval(() => {
      if (window.googletag) {
        setGoogleAD();
        clearInterval(googleReady);
      }
    }, 1000);
  }

    return(
      <div className="goart_content">
        <div className="layout">
          <DialogOpenApp />
          <Header />
          <div className={`layout-content ${loading ? "layout-content-loading" : ""} ${isMobile ? "layout-content-mobile" : ""} ${!currentImage ? "layout-content-noimage" : ""}`}>
          <div style={{display:hasNeedRoot?'flex':'none'}}  className={'goart_content-root_fra'}>
            <div className={'goart_content-root_fra_inner'}>
              <div onClick={()=>{
                FTImageStore.checkRoot={...FTImageStore.checkRoot,need:false}
                FTImageStore.currentEffect = FTImageStore.prevEffect
              }} className={'goart_content-root_fra_inner_close'}>
                <IconClose/>
              </div>
              <p className="goart_content-root_fra_inner_titles">{FTLang._('goart_aigc_root_titles')}</p>
              <p className="goart_content-root_fra_inner_second_titles">{FTLang._('goart_aigc_root_second_titles')}</p>
              <div id="goart_content-root_fra" >

              </div>
            </div>
          </div>

            {!isMobile && <ToolLeft className="layout-content_left"/>}
            <FTCenter className="layout-content_canvas"/>
            {isMobile && <ToolLeftMobile className="layout-content_left" />}
            </div>

            {effectLoading && <div className="layout_effect_loading">
              <FTEffectLoading />
            </div>}
            { downloadLoading && <div className="layout_effect_loading">
                <FTDownloadLoading />
              </div>
            }
            {/* {downloadImage && <FTImageDownloadMark />} */}
            {showDownload && isMobile && <FTDownloadMobile />}
        </div>
        {!isMobile && showAd && <div className="goart_ad">
              <div id="uniconsent-config">
                <a id="unic-gdpr" onClick={() => {window.__tcfapi("openunic");return false;}} style={{display:"none",cursor:"pointer"}}>Change Ad Consent</a>
                <a id="unic-ccpa" onClick={() => {window.__uspapi('openunic'); return false;}} style={{display:"none",cursor:"pointer"}}>Do not sell my data</a>
              </div>
              <div className="goart_ad_btn">
                <div
                  onClick={() => closeAD()}
                  className="main__new_delete"
                >
                  <IconVip />
                  { FTLang._("remove_ad_btn")}
                </div>
              </div>
            </div>
          }
        {useActivity && <ScriptModal type={useActivity} />}
      </div>
    )
}